<template>
    <div class="card">
      <div class="card-body">
        <router-link to="/ProductAttribute/Add" data-toggle="tooltip" title="افزودن ویژگی" class="btn btn-info mb-2" ><i class="far fa-plus"></i></router-link>
        <LocalDataTable :functions="functions" :init-document="is_mounted" :columns="columns" :ajax-link="route"></LocalDataTable>
      </div>
    </div>
</template>

<script>
let mounted = false;
import MasterLayout from "@/components/MasterLayout";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
import Swal from "sweetalert2";
import {AppApi} from "@/api/AppApi";
import {showSystemNoti} from "@/shared/helper";
export default {
name: "ManagePage",
  components: {LocalDataTable, MasterLayout},
  data()
  {
    return {
      is_mounted : mounted,
      functions:[
        {name: 'delFunc',method : this.delFunc}
      ],
      columns: [
        {title: 'عنوان'},
        {title: '<i class="far fa-cogs"></i>', searchable: false, sortable: false}
      ],
      route: 'productAttribute/List'
    }
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async delFunc(id,element)
    {
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: "تمام اطلاعات مربوط به ویژگی محصول و مقادیر آن حذف می شود.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید حذف!',
        cancelButtonText: 'کنسل',
      }).then(async (result) => {
        if (result.value) {
          const result = await AppApi.deleteProductBrandAttribute(id);
          if (result.ok)
          {
            if (element)
              $(element).closest('tr').remove();
            showSystemNoti('success', result.message);
          }
          else
            showSystemNoti('danger',result.error);
        }
      })
    }
  },
  async mounted()
  {
    this.setPageTitle('ویژگی های محصولات');
    this.setShowHead(true);
    this.is_mounted = mounted;
    mounted = true;
  }
}
</script>

<style scoped>

</style>